module.exports = __webpack_public_path__ + "media/78_Long.7eeb4ed1.mp3";